import { render, staticRenderFns } from "./NavTab.vue?vue&type=template&id=6f9089ca&scoped=true&"
import script from "./NavTab.vue?vue&type=script&lang=ts&"
export * from "./NavTab.vue?vue&type=script&lang=ts&"
import style0 from "./nav_tab.scss?vue&type=style&index=0&id=6f9089ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9089ca",
  null
  
)

export default component.exports